module.exports = __webpack_public_path__ + "img/54.ae45581d.jpg";